import { useEffect, useState } from 'react';

import type { Segment, SegmentList } from '@/pages/segments/api-types';

import http from './http';

// One GET /segments shared by every chip, tag and picker on the page, fetched again after 30 s.
let segmentsCache: { at: number; promise: Promise<SegmentList> } | null = null;
const fetchSegments = () => {
  if (!segmentsCache || Date.now() - segmentsCache.at > 30_000) {
    segmentsCache = { at: Date.now(), promise: http.get<SegmentList>('/segments').then((r) => r.data) };
  }
  return segmentsCache.promise;
};

/** Drops the shared segments, so the next page shows a segment just saved (its colour too). */
export const forgetSegments = () => {
  segmentsCache = null;
};

/** The segments that exist (GET /segments), and a lookup by id or by name. */
export const useSegments = () => {
  const [data, setData] = useState<SegmentList | null>(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let live = true;
    fetchSegments()
      .then((d) => live && setData(d))
      .catch(() => {
        segmentsCache = null;
        if (live) setError(true);
      });
    return () => {
      live = false;
    };
  }, []);
  const items = data?.items ?? [];
  return {
    items,
    loaded: Boolean(data),
    error,
    byId: (id: string): Segment | undefined => items.find((s) => s.id === id),
    byName: (name: string): Segment | undefined => items.find((s) => s.name.trim().toLowerCase() === name.trim().toLowerCase()),
  };
};
